import { c as _c } from "react/compiler-runtime";
import SpinnerLoader from "@/components/common/SpinnerLoader";
import CircleLoader from "@/components/distribution-plan-tool/common/CircleLoader";
import { ArrowTopRightOnSquareIcon, ChevronDownIcon, PlusIcon, XMarkIcon } from "@heroicons/react/24/outline";
import type { ReactNode, RefObject } from "react";
export function LoadingPanel(t0) {
  const $ = _c(5);
  const {
    label
  } = t0;
  let t1;
  if ($[0] !== label) {
    t1 = <div className="tw-p-6 sm:tw-p-8"><SpinnerLoader text={label} /></div>;
    $[0] = label;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== label || $[3] !== t1) {
    t2 = <section aria-label={label}>{t1}</section>;
    $[2] = label;
    $[3] = t1;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  return t2;
}
export function InfoPanel(t0) {
  const $ = _c(12);
  const {
    title,
    message,
    actions
  } = t0;
  let t1;
  if ($[0] !== title) {
    t1 = <h2 className="tw-mb-0 tw-text-xl tw-font-semibold tw-text-iron-50">{title}</h2>;
    $[0] = title;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== message) {
    t2 = <p className="tw-mb-0 tw-mt-3 tw-text-sm tw-leading-6 tw-text-iron-400">{message}</p>;
    $[2] = message;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== t1 || $[5] !== t2) {
    t3 = <div className="tw-max-w-2xl">{t1}{t2}</div>;
    $[4] = t1;
    $[5] = t2;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  let t4;
  if ($[7] !== actions) {
    t4 = actions !== undefined && <div className="tw-mt-5 tw-flex tw-flex-wrap tw-justify-center tw-gap-3">{actions}</div>;
    $[7] = actions;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  let t5;
  if ($[9] !== t3 || $[10] !== t4) {
    t5 = <section><div className="tw-flex tw-flex-col tw-items-center tw-justify-center tw-p-6 tw-text-center sm:tw-p-8">{t3}{t4}</div></section>;
    $[9] = t3;
    $[10] = t4;
    $[11] = t5;
  } else {
    t5 = $[11];
  }
  return t5;
}
export function CurationEmptyPanel(t0) {
  const $ = _c(15);
  const {
    title,
    message,
    primaryAction
  } = t0;
  let t1;
  let t2;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <div aria-hidden={true} className="tw-pointer-events-none tw-absolute tw-inset-0 tw-bg-[radial-gradient(circle_at_center,rgba(255,255,255,0.06),transparent_62%)]" />;
    t2 = <div aria-hidden={true} className="tw-pointer-events-none tw-absolute tw-left-1/2 tw-top-1/2 tw-h-80 tw-w-80 -tw-translate-x-1/2 -tw-translate-y-1/2 tw-rounded-full tw-bg-white/5 tw-blur-3xl" />;
    $[0] = t1;
    $[1] = t2;
  } else {
    t1 = $[0];
    t2 = $[1];
  }
  let t3;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <div className="tw-flex tw-h-14 tw-w-14 tw-items-center tw-justify-center tw-rounded-2xl tw-border tw-border-solid tw-border-white/10 tw-bg-white/5 tw-shadow-[0_18px_60px_rgba(255,255,255,0.08)] sm:tw-h-20 sm:tw-w-20 sm:tw-rounded-[1.75rem]"><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true" className="tw-h-6 tw-w-6 tw-text-iron-200 sm:tw-h-9 sm:tw-w-9"><rect width="7" height="9" x="3" y="3" rx="1" /><rect width="7" height="5" x="14" y="3" rx="1" /><rect width="7" height="9" x="14" y="12" rx="1" /><rect width="7" height="5" x="3" y="16" rx="1" /></svg></div>;
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  let t4;
  if ($[3] !== title) {
    t4 = <h2 className="tw-mb-0 tw-text-lg tw-font-semibold tw-text-iron-100 md:tw-text-xl">{title}</h2>;
    $[3] = title;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  let t5;
  if ($[5] !== message) {
    t5 = <p className="tw-mb-0 tw-mt-2 tw-text-sm tw-font-normal tw-leading-relaxed tw-text-iron-500 md:tw-mt-3">{message}</p>;
    $[5] = message;
    $[6] = t5;
  } else {
    t5 = $[6];
  }
  let t6;
  if ($[7] !== t4 || $[8] !== t5) {
    t6 = <div className="tw-mt-6 tw-max-w-xl md:tw-mt-8">{t4}{t5}</div>;
    $[7] = t4;
    $[8] = t5;
    $[9] = t6;
  } else {
    t6 = $[9];
  }
  let t7;
  if ($[10] !== primaryAction) {
    t7 = primaryAction !== undefined && <div className="tw-mt-6 tw-flex tw-flex-col tw-items-center tw-gap-4 md:tw-mt-8">{primaryAction}</div>;
    $[10] = primaryAction;
    $[11] = t7;
  } else {
    t7 = $[11];
  }
  let t8;
  if ($[12] !== t6 || $[13] !== t7) {
    t8 = <section className="tw-relative tw-overflow-hidden tw-rounded-[2rem] tw-border tw-border-solid tw-border-white/10 tw-bg-black">{t1}{t2}<div className="tw-relative tw-flex tw-min-h-[240px] tw-flex-col tw-items-center tw-justify-center tw-px-4 tw-py-10 tw-text-center sm:tw-min-h-[360px] sm:tw-px-8 sm:tw-py-16">{t3}{t6}{t7}</div></section>;
    $[12] = t6;
    $[13] = t7;
    $[14] = t8;
  } else {
    t8 = $[14];
  }
  return t8;
}
export function RetryButton(t0) {
  const $ = _c(6);
  const {
    isLoading,
    onClick
  } = t0;
  let t1;
  if ($[0] !== isLoading) {
    t1 = isLoading ? <CircleLoader /> : "Retry";
    $[0] = isLoading;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== isLoading || $[3] !== onClick || $[4] !== t1) {
    t2 = <button type="button" onClick={onClick} disabled={isLoading} className="tw-inline-flex tw-items-center tw-justify-center tw-gap-2 tw-rounded-lg tw-border tw-border-solid tw-border-white/10 tw-bg-iron-950 tw-px-3.5 tw-py-2 tw-text-xs tw-font-semibold tw-text-iron-200 tw-transition tw-duration-300 tw-ease-out focus-visible:tw-outline focus-visible:tw-outline-2 focus-visible:tw-outline-offset-2 focus-visible:tw-outline-iron-400 disabled:tw-cursor-not-allowed disabled:tw-border-white/5 disabled:tw-text-iron-500 desktop-hover:hover:tw-border-iron-700 desktop-hover:hover:tw-bg-iron-900">{t1}</button>;
    $[2] = isLoading;
    $[3] = onClick;
    $[4] = t1;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  return t2;
}
export function OfficialWaveSummary(t0) {
  const $ = _c(39);
  const {
    waveName,
    metadataLabel,
    profileCurationLabel,
    canManageOwnOfficialWave,
    changeWaveDropdown,
    changeCurationDropdown,
    changeWaveDropdownRef,
    changeCurationDropdownRef,
    changeWaveButtonRef,
    changeCurationButtonRef,
    isChangeWaveOpen,
    isChangeCurationOpen: t1,
    isRemoving,
    isChangingCuration: t2,
    showChangeCuration: t3,
    onOpenWave,
    onAddPost,
    onOpenChangeWave,
    onOpenChangeCuration,
    onRemoveWave
  } = t0;
  const isChangeCurationOpen = t1 === undefined ? false : t1;
  const isChangingCuration = t2 === undefined ? false : t2;
  const showChangeCuration = t3 === undefined ? false : t3;
  const changeWaveDropdownId = changeWaveDropdown === undefined ? undefined : "change-wave-dropdown";
  const changeCurationDropdownId = changeCurationDropdown === undefined ? undefined : "change-curation-dropdown";
  let t4;
  if ($[0] !== waveName) {
    t4 = <h2 className="tw-mb-0 tw-min-w-0 tw-max-w-full tw-text-xl tw-font-semibold tw-text-iron-100">{waveName}</h2>;
    $[0] = waveName;
    $[1] = t4;
  } else {
    t4 = $[1];
  }
  const t5 = `Open wave ${waveName}`;
  let t6;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = <ArrowTopRightOnSquareIcon className="tw-h-3.5 tw-w-3.5 tw-flex-shrink-0" />;
    $[2] = t6;
  } else {
    t6 = $[2];
  }
  let t7;
  if ($[3] !== onOpenWave || $[4] !== t5) {
    t7 = <button type="button" onClick={onOpenWave} aria-label={t5} title="Open wave" className="tw-ml-2 tw-inline-flex tw-h-7 tw-w-7 tw-flex-shrink-0 tw-items-center tw-justify-center tw-rounded-lg tw-border tw-border-solid tw-border-white/10 tw-bg-white/5 tw-text-iron-300 tw-transition tw-duration-300 tw-ease-out focus-visible:tw-outline focus-visible:tw-outline-2 focus-visible:tw-outline-offset-2 focus-visible:tw-outline-iron-300 desktop-hover:hover:tw-border-white/15 desktop-hover:hover:tw-bg-white/10 desktop-hover:hover:tw-text-iron-100">{t6}</button>;
    $[3] = onOpenWave;
    $[4] = t5;
    $[5] = t7;
  } else {
    t7 = $[5];
  }
  let t8;
  if ($[6] !== t4 || $[7] !== t7) {
    t8 = <div className="tw-col-start-1 tw-row-start-1 tw-min-w-0 tw-max-w-2xl"><div className="tw-flex tw-items-center">{t4}{t7}</div></div>;
    $[6] = t4;
    $[7] = t7;
    $[8] = t8;
  } else {
    t8 = $[8];
  }
  let t9;
  if ($[9] !== metadataLabel) {
    t9 = <span className="tw-text-iron-400">{metadataLabel}</span>;
    $[9] = metadataLabel;
    $[10] = t9;
  } else {
    t9 = $[10];
  }
  let t10;
  if ($[11] !== profileCurationLabel) {
    t10 = profileCurationLabel && <><span className="tw-text-iron-600">•</span><span className="tw-inline-flex tw-max-w-full tw-items-center tw-gap-1.5 tw-text-sm tw-font-medium tw-leading-6 tw-text-iron-300"><span className="tw-flex-shrink-0 tw-text-iron-500">Curation:</span><span className="tw-min-w-0 tw-truncate tw-text-iron-200">{profileCurationLabel}</span></span></>;
    $[11] = profileCurationLabel;
    $[12] = t10;
  } else {
    t10 = $[12];
  }
  let t11;
  if ($[13] !== t10 || $[14] !== t9) {
    t11 = <div className="tw-col-span-full tw-row-start-2 tw-flex tw-min-w-0 tw-flex-wrap tw-items-center tw-gap-x-2 tw-gap-y-1 tw-text-sm tw-leading-6 lg:tw-col-start-1 lg:tw-col-end-2 lg:tw-mt-2">{t9}{t10}</div>;
    $[13] = t10;
    $[14] = t9;
    $[15] = t11;
  } else {
    t11 = $[15];
  }
  let t12;
  if ($[16] !== canManageOwnOfficialWave || $[17] !== changeCurationButtonRef || $[18] !== changeCurationDropdown || $[19] !== changeCurationDropdownId || $[20] !== changeCurationDropdownRef || $[21] !== changeWaveButtonRef || $[22] !== changeWaveDropdown || $[23] !== changeWaveDropdownId || $[24] !== changeWaveDropdownRef || $[25] !== isChangeCurationOpen || $[26] !== isChangeWaveOpen || $[27] !== isChangingCuration || $[28] !== isRemoving || $[29] !== onAddPost || $[30] !== onOpenChangeCuration || $[31] !== onOpenChangeWave || $[32] !== onRemoveWave || $[33] !== showChangeCuration) {
    t12 = canManageOwnOfficialWave && <div className="tw-contents lg:tw-col-start-2 lg:tw-row-span-2 lg:tw-row-start-1 lg:tw-flex lg:tw-items-start lg:tw-justify-end lg:tw-gap-2">{onAddPost !== undefined && <button type="button" onClick={onAddPost} className="tw-col-start-2 tw-row-start-1 tw-inline-flex tw-flex-shrink-0 tw-items-center tw-justify-center tw-gap-1.5 tw-whitespace-nowrap tw-rounded-lg tw-border tw-border-solid tw-border-white tw-bg-white tw-px-3.5 tw-py-2 tw-text-sm tw-font-semibold tw-text-iron-950 tw-transition tw-duration-300 tw-ease-out focus-visible:tw-outline focus-visible:tw-outline-2 focus-visible:tw-outline-offset-2 focus-visible:tw-outline-white desktop-hover:hover:tw-border-iron-200 desktop-hover:hover:tw-bg-iron-100 sm:tw-py-1.5 tw-self-center"><PlusIcon className="-tw-ml-1 tw-h-4 tw-w-4 tw-flex-shrink-0" /><span className="tw-text-xs sm:tw-text-sm">Add post</span></button>}<fieldset className="horizontal-menu-hide-scrollbar tw-col-span-full tw-row-start-3 tw-mt-2 tw-w-full tw-overflow-x-auto lg:tw-mt-0 lg:tw-w-auto lg:tw-overflow-visible"><legend className="tw-sr-only">Profile wave switch controls</legend><div className="tw-flex tw-w-max tw-items-center tw-gap-2 lg:tw-w-auto lg:tw-justify-end"><div className="tw-flex tw-w-auto tw-flex-shrink-0 tw-items-center tw-gap-0.5 tw-rounded-lg tw-border tw-border-solid tw-border-white/10 tw-bg-white/5 tw-p-0.5 tw-shadow-[0_12px_30px_rgba(0,0,0,0.18)]"><div ref={changeWaveDropdownRef} className="tw-relative tw-flex-none"><button ref={changeWaveButtonRef} type="button" onClick={onOpenChangeWave} aria-expanded={isChangeWaveOpen} aria-haspopup="menu" aria-controls={changeWaveDropdownId} className={`tw-inline-flex tw-w-auto tw-items-center tw-justify-center tw-gap-2 tw-whitespace-nowrap tw-rounded-lg tw-border tw-border-solid tw-px-3 tw-py-1.5 tw-text-sm tw-font-semibold tw-transition tw-duration-300 tw-ease-out focus-visible:tw-outline focus-visible:tw-outline-2 focus-visible:tw-outline-offset-2 focus-visible:tw-outline-iron-300 sm:tw-px-3.5 sm:tw-py-2 md:tw-py-1.5 ${isChangeWaveOpen ? "tw-border-white/10 tw-bg-iron-800 tw-text-iron-50 tw-shadow-inner" : "tw-border-transparent tw-bg-transparent tw-text-iron-200 desktop-hover:hover:tw-bg-white/5 desktop-hover:hover:tw-text-iron-50"}`}><span className="tw-text-xs lg:tw-text-sm">Switch wave</span><ChevronDownIcon aria-hidden="true" className={`-tw-mr-1.5 tw-h-4 tw-w-4 tw-flex-shrink-0 tw-transition tw-duration-200 ${isChangeWaveOpen ? "tw-rotate-180" : ""}`} /></button>{changeWaveDropdownId && <div id={changeWaveDropdownId} className="tw-absolute tw-right-0 tw-top-full tw-z-20 tw-mt-1 tw-hidden tw-w-72 lg:tw-block">{changeWaveDropdown}</div>}</div>{showChangeCuration && onOpenChangeCuration !== undefined && <><div className="tw-mx-1 tw-h-3.5 tw-w-px tw-flex-shrink-0 tw-bg-white/10" /><div ref={changeCurationDropdownRef} className="tw-relative tw-flex-none"><button ref={changeCurationButtonRef} type="button" onClick={onOpenChangeCuration} disabled={isChangingCuration} aria-expanded={isChangeCurationOpen} aria-haspopup="menu" aria-controls={changeCurationDropdownId} className={`tw-inline-flex tw-w-auto tw-items-center tw-justify-center tw-gap-2 tw-whitespace-nowrap tw-rounded-lg tw-border tw-border-solid tw-px-3 tw-py-1.5 tw-text-sm tw-font-semibold tw-transition tw-duration-300 tw-ease-out focus-visible:tw-outline focus-visible:tw-outline-2 focus-visible:tw-outline-offset-2 focus-visible:tw-outline-iron-300 disabled:tw-cursor-not-allowed disabled:tw-text-iron-600 sm:tw-px-3.5 sm:tw-py-2 md:tw-py-1.5 ${isChangeCurationOpen ? "tw-border-white/10 tw-bg-iron-800 tw-text-iron-50 tw-shadow-inner" : "tw-border-transparent tw-bg-transparent tw-text-iron-200 desktop-hover:hover:tw-bg-white/5 desktop-hover:hover:tw-text-iron-50"}`}><span className="tw-text-xs lg:tw-text-sm">Switch curation</span><ChevronDownIcon aria-hidden="true" className={`-tw-mr-1.5 tw-h-4 tw-w-4 tw-flex-shrink-0 tw-transition tw-duration-200 ${isChangeCurationOpen ? "tw-rotate-180" : ""}`} /></button>{changeCurationDropdownId && <div id={changeCurationDropdownId} className="tw-absolute tw-right-0 tw-top-full tw-z-20 tw-mt-1 tw-hidden tw-w-72 lg:tw-block">{changeCurationDropdown}</div>}</div></>}<div className="tw-mx-1 tw-h-3.5 tw-w-px tw-flex-shrink-0 tw-bg-white/10" /><button type="button" onClick={onRemoveWave} disabled={isRemoving} aria-label="Unset featured wave" title="Unset featured wave" className="tw-inline-flex tw-flex-shrink-0 tw-items-center tw-justify-center tw-gap-1.5 tw-rounded-[10px] tw-border tw-border-solid tw-border-transparent tw-bg-transparent tw-px-2.5 tw-py-1.5 tw-text-sm tw-font-semibold tw-text-zinc-500 tw-transition tw-duration-300 tw-ease-out focus-visible:tw-outline focus-visible:tw-outline-2 focus-visible:tw-outline-offset-2 focus-visible:tw-outline-rose-400 disabled:tw-cursor-not-allowed disabled:tw-text-iron-600 desktop-hover:hover:tw-border-rose-500/20 desktop-hover:hover:tw-bg-rose-500/10 desktop-hover:hover:tw-text-rose-400 sm:tw-px-3.5 sm:tw-py-1.5">{isRemoving ? <CircleLoader /> : <XMarkIcon className="tw-h-4 tw-w-4 tw-flex-shrink-0" />}<span className="tw-text-xs lg:tw-text-sm">Unset</span></button></div></div></fieldset></div>;
    $[16] = canManageOwnOfficialWave;
    $[17] = changeCurationButtonRef;
    $[18] = changeCurationDropdown;
    $[19] = changeCurationDropdownId;
    $[20] = changeCurationDropdownRef;
    $[21] = changeWaveButtonRef;
    $[22] = changeWaveDropdown;
    $[23] = changeWaveDropdownId;
    $[24] = changeWaveDropdownRef;
    $[25] = isChangeCurationOpen;
    $[26] = isChangeWaveOpen;
    $[27] = isChangingCuration;
    $[28] = isRemoving;
    $[29] = onAddPost;
    $[30] = onOpenChangeCuration;
    $[31] = onOpenChangeWave;
    $[32] = onRemoveWave;
    $[33] = showChangeCuration;
    $[34] = t12;
  } else {
    t12 = $[34];
  }
  let t13;
  if ($[35] !== t11 || $[36] !== t12 || $[37] !== t8) {
    t13 = <div className="tw-grid tw-grid-cols-[minmax(0,1fr)_auto] tw-items-start tw-gap-x-3 tw-gap-y-2 lg:tw-gap-y-0">{t8}{t11}{t12}</div>;
    $[35] = t11;
    $[36] = t12;
    $[37] = t8;
    $[38] = t13;
  } else {
    t13 = $[38];
  }
  return t13;
}